import React, { useState } from 'react';
import * as R from 'ramda';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { PersistentDataGrid, useCustomizablePopover } from 'common';
import FilterableDataGrid from '../../common/templates/FilterableDataGrid';

const mockSupplierAuths = [
  { authId: '854697', supplier: 'Apex Crude Corp' },
  { authId: '854698', supplier: 'Global Industries' },
  { authId: '854699', supplier: 'TechStart Inc' },
  { authId: '854700', supplier: 'Innovative Solutions' },
  { authId: '854697', supplier: 'Apex Crude Corp' },
  { authId: '854698', supplier: 'Global Industries' },
  { authId: '854699', supplier: 'TechStart Inc' },
  { authId: '854700', supplier: 'Innovative Solutions' },
  { authId: '854700', supplier: 'Innovative Solutions' },
  { authId: '854700', supplier: 'Innovative Solutions' },
];

const rows = [
  {
    age: 35,
    authId: '54114',
    customersRestricted: null,
    firstName: 'Jon',
    id: 1,
    lastName: 'Snow',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 42,
    customersRestricted: [
      { authId: '854697', supplier: 'Apex Crude Corp' },
      { authId: '854698', supplier: 'Global Industries' },
    ],
    firstName: 'Cer sei',
    id: 2,
    lastName: 'Lannister',
    supplier: 'Global Industries',
  },
  {
    age: 16,
    customersRestricted: mockSupplierAuths,
    firstName: 'Arya',
    id: 3,
    lastName: 'Stark',
    supplier: 'TechStart Inc',
  },
  {
    age: 28,
    customersRestricted: null,
    firstName: 'Daenerys',
    id: 4,
    lastName: 'Targaryen',
    supplier: 'Innovative Solutions',
  },
  {
    age: 150,
    customersRestricted: [
      { authId: '854697', supplier: 'Some Other Company' },
      { authId: '854698', supplier: 'Another More Interesting Company' },
    ],
    firstName: null,
    id: 5,
    lastName: 'Melisandre',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 44,
    customersRestricted: null,
    firstName: 'Ferrara',
    id: 6,
    lastName: 'Clifford',
    supplier: 'Global Industries',
  },
  {
    age: 36,
    customersRestricted: null,
    firstName: 'Rossini',
    id: 7,
    lastName: 'Frances',
    supplier: 'TechStart Inc',
  },
  {
    age: 65,
    customersRestricted: null,
    firstName: 'Harvey',
    id: 8,
    lastName: 'Roxie',
    supplier: 'Innovative Solutions',
  },
  {
    age: 29,
    customersRestricted: null,
    firstName: 'Tyrion',
    id: 9,
    lastName: 'Lannister',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 31,
    customersRestricted: null,
    firstName: 'Jaime',
    id: 10,
    lastName: 'Lannister',
    supplier: 'Global Industries',
  },
  {
    age: 45,
    customersRestricted: null,
    firstName: 'Robert',
    id: 11,
    lastName: 'Baratheon',
    supplier: 'TechStart Inc',
  },
  {
    age: 33,
    customersRestricted: null,
    firstName: 'Sansa',
    id: 12,
    lastName: 'Stark',
    supplier: 'Innovative Solutions',
  },
  {
    age: 24,
    customersRestricted: null,
    firstName: 'Bran',
    id: 13,
    lastName: 'Stark',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 27,
    customersRestricted: null,
    firstName: 'Theon',
    id: 14,
    lastName: 'Greyjoy',
    supplier: 'Global Industries',
  },
  {
    age: 38,
    customersRestricted: null,
    firstName: 'Jorah',
    id: 15,
    lastName: 'Mormont',
    supplier: 'TechStart Inc',
  },
  {
    age: 52,
    customersRestricted: null,
    firstName: 'Tywin',
    id: 16,
    lastName: 'Lannister',
    supplier: 'Innovative Solutions',
  },
  {
    age: 41,
    customersRestricted: null,
    firstName: 'Catelyn',
    id: 17,
    lastName: 'Stark',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 48,
    customersRestricted: null,
    firstName: 'Ned',
    id: 18,
    lastName: 'Stark',
    supplier: 'Global Industries',
  },
  {
    age: 22,
    customersRestricted: null,
    firstName: 'Robb',
    id: 19,
    lastName: 'Stark',
    supplier: 'TechStart Inc',
  },
  {
    age: 19,
    customersRestricted: null,
    firstName: 'Margaery',
    id: 20,
    lastName: 'Tyrell',
    supplier: 'Innovative Solutions',
  },
  {
    age: 25,
    customersRestricted: null,
    firstName: 'Loras',
    id: 21,
    lastName: 'Tyrell',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 54,
    customersRestricted: null,
    firstName: 'Olenna',
    id: 22,
    lastName: 'Tyrell',
    supplier: 'Global Industries',
  },
  {
    age: 30,
    customersRestricted: null,
    firstName: 'Oberyn',
    id: 23,
    lastName: 'Martell',
    supplier: 'TechStart Inc',
  },
  {
    age: 43,
    customersRestricted: 6,
    firstName: 'Stannis',
    id: 24,
    lastName: 'Baratheon',
    supplier: 'Innovative Solutions',
  },
  {
    age: 39,
    customersRestricted: null,
    firstName: 'Davos',
    id: 25,
    lastName: 'Seaworth',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 26,
    customersRestricted: null,
    firstName: 'Brienne',
    id: 26,
    lastName: 'Tarth',
    supplier: 'Global Industries',
  },
  {
    age: 32,
    customersRestricted: null,
    firstName: 'Sandor',
    id: 27,
    lastName: 'Clegane',
    supplier: 'TechStart Inc',
  },
  {
    age: 40,
    customersRestricted: null,
    firstName: 'Gregor',
    id: 28,
    lastName: 'Clegane',
    supplier: 'Innovative Solutions',
  },
  {
    age: 23,
    customersRestricted: null,
    firstName: 'Tommen',
    id: 29,
    lastName: 'Baratheon',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 18,
    customersRestricted: null,
    firstName: 'Myrcella',
    id: 30,
    lastName: 'Baratheon',
    supplier: 'Global Industries',
  },
  {
    age: 34,
    customersRestricted: null,
    firstName: 'Petyr',
    id: 31,
    lastName: 'Baelish',
    supplier: 'TechStart Inc',
  },
  {
    age: 37,
    customersRestricted: null,
    firstName: 'Varys',
    id: 32,
    lastName: 'Unknown',
    supplier: 'Innovative Solutions',
  },
  {
    age: 28,
    customersRestricted: null,
    firstName: 'Missandei',
    id: 33,
    lastName: 'Unknown',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 21,
    customersRestricted: null,
    firstName: 'Grey',
    id: 34,
    lastName: 'Worm',
    supplier: 'Global Industries',
  },
  {
    age: 29,
    customersRestricted: null,
    firstName: 'Ygritte',
    id: 35,
    lastName: 'Unknown',
    supplier: 'TechStart Inc',
  },
  {
    age: 47,
    customersRestricted: null,
    firstName: 'Tormund',
    id: 36,
    lastName: 'Giantsbane',
    supplier: 'Innovative Solutions',
  },
  {
    age: 50,
    customersRestricted: null,
    firstName: 'Mance',
    id: 37,
    lastName: 'Rayder',
    supplier: 'Apex Crude Corp',
  },
  {
    age: 33,
    customersRestricted: null,
    firstName: 'Ramsay',
    id: 38,
    lastName: 'Bolton',
    supplier: 'Global Industries',
  },
];

// Mock function to simulate fetching restricted customers by row ID
// In real implementation, this could be an API call or Redux selector
const getRestrictedCustomersById = rowId => {
  const row = rows.find(r => r.id === rowId);
  return row?.customersRestricted || [];
};

export default function FiltrableDataGridPreview() {
  const [filters, setFilters] = useState();
  const [activeRowId, setActiveRowId] = useState(null);
  const [showAllRestricted, setShowAllRestricted] = useState(false);

  // Single import and hook call - returns everything needed including the Popover component
  const { handlePopoverOpen, handlePopoverClose, Popover } = useCustomizablePopover();

  // Get the restricted customers for the currently hovered row
  const restrictedCustomers = activeRowId ? getRestrictedCustomersById(activeRowId) : [];

  const columns = [
    { field: 'id', headerName: 'ID', width: 90 },
    { field: 'firstName', headerName: 'First name', width: 150 },
    { field: 'lastName', headerName: 'Last name', width: 150 },
    { field: 'age', headerName: 'Age', type: 'number', width: 110 },
    {
      field: 'customersRestricted',
      headerName: 'Restricted Customers',
      renderCell: params =>
        R.isNil(params.value) || params.value.length === 0 ? (
          <Typography variant="body2">Unrestricted</Typography>
        ) : (
          <>
            <Box
              onMouseEnter={e => {
                setActiveRowId(params.row.id);
                handlePopoverOpen(e);
              }}
              onMouseLeave={e => {
                handlePopoverClose(e);
                // activeRowId will persist until next hover - this prevents flickering
              }}
              sx={{
                cursor: 'pointer',
                display: 'inline-flex',
                py: 1,
              }}
            >
              <Typography sx={{ pointerEvents: 'none' }} variant="link">
                {params.value?.length ?? 0}
              </Typography>
            </Box>
          </>
        ),
      type: 'number',
      width: 150,
    },
  ];

  const handleChange = field => (event, newValue) => {
    setFilters(prev => ({ ...prev, [field]: newValue }));
  };

  const handleReset = () => {
    setFilters({});
  };

  const onApply = () => {};

  const filterOptions = [
    {
      disableClearable: true,
      onChange: handleChange('inventoryOwner'),
      options: [
        'Acme Corp',
        'Global Industries',
        'TechStart Inc',
        'Summit Logistics',
        'Horizon Trading',
      ],
      renderInput: params => <TextField {...params} label="Inventory Owner" />,
    },
    {
      disableClearable: true,
      onChange: handleChange('suppliers'),
      options: ['Supplier A', 'Supplier B', 'Supplier C', 'Supplier D', 'Supplier E'],
      renderInput: params => <TextField {...params} label="Suppliers" />,
    },
    {
      disableClearable: true,
      onChange: handleChange('product'),
      options: ['Gasoline 87', 'Gasoline 91', 'Diesel', 'Premium Diesel', 'Ethanol Blend'],
      renderInput: params => <TextField {...params} label="Product" />,
    },
    {
      disableClearable: true,
      onChange: handleChange('volume'),
      options: ['0-1000', '1000-5000', '5000-10000', '10000-50000', '50000+'],
      renderInput: params => <TextField {...params} label="Volume" />,
    },
    {
      disableClearable: true,
      onChange: handleChange('rvp'),
      options: ['7.0', '7.8', '9.0', '11.5', '13.5'],
      renderInput: params => <TextField {...params} label="RVP" />,
    },
  ];

  // Filter Logic
  const filterContent = (
    <>
      {filterOptions &&
        filterOptions.map(option => (
          <Autocomplete
            disableClearable={option.disableClearable}
            key={option.label}
            onChange={option.onChange}
            options={option.options}
            renderInput={option.renderInput}
            value={option.value}
          />
        ))}
    </>
  );

  return (
    <div style={{ height: 400, width: '100%' }}>
      <FilterableDataGrid
        filterActionButtonSpacing="space-between"
        filterContent={filterContent}
        filters={filters}
        handleReset={handleReset}
        hasChanges={() => {}}
        hasCreatePermissions
        headerTitle="Main Panel"
        onApply={onApply}
        onCreateClick={() => {}}
        primaryActionButtonTitle="Bulk Actions"
        primaryFilterActionButtonLabel="Apply"
        secondaryFilterActionButtonLabel="Reset"
        singleActionButtonTitle="Create New"
      >
        <PersistentDataGrid
          checkboxSelection
          columns={columns}
          disableSelectionOnClick
          pageSize={10}
          quickFilter
          rows={rows}
          rowsPerPageOptions={[5, 10, 20]}
        />
        <Popover
          id="restricted-customers-popover"
          popoverFooterContent={
            // Show footer only if there are more than 5 items
            !showAllRestricted &&
            restrictedCustomers.length > 5 && (
              <Typography
                onClick={() => setShowAllRestricted(true)}
                sx={{ cursor: 'pointer' }}
                variant="link"
              >
                + {restrictedCustomers.length - 5} More
              </Typography>
            )
          }
          popoverHeaderContent={<Typography variant="body1bold">Restricted Customers</Typography>}
          popoverMainContent={
            <Stack spacing={1} sx={{ backgroundColor: 'surface.white' }}>
              {(showAllRestricted ? restrictedCustomers : restrictedCustomers.slice(0, 5)).map(
                customer => (
                  <Box
                    key={`restricted-customer-${customer.authId}-${customer.supplier}`}
                    sx={{
                      alignItems: 'baseline',
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    {customer.supplier.length > 18 ? (
                      <Tooltip placement="top-start" title={customer.supplier}>
                        <Typography
                          sx={{
                            color: 'text.primary',
                            maxWidth: 150,
                            mr: 1,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                          variant="body1"
                        >
                          {customer.supplier}
                        </Typography>
                      </Tooltip>
                    ) : (
                      <Typography
                        sx={{
                          color: 'text.primary',
                          maxWidth: 150,
                          mr: 1,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                        variant="body1"
                      >
                        {customer.supplier}
                      </Typography>
                    )}
                    <Typography sx={{ color: 'text.primary' }} variant="subtitle2">
                      {customer.authId}
                    </Typography>
                  </Box>
                )
              )}
            </Stack>
          }
          sx={{ maxWidth: '100' }}
        />
      </FilterableDataGrid>
    </div>
  );
}
